<div
  #trigger="cdkOverlayOrigin"
  (click)="isOpen = true" cdkOverlayOrigin class="filter-button status-filter flex flex-row gap-[20px]" type="button"
>
  <div class="label text-type-8">{{ buttonLabel }}</div>
  <mat-icon
    class="filter-icon"
    svgIcon="filters"
  />
</div>

<ng-template
  (backdropClick)="isOpen = false"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  cdkConnectedOverlay
>
  <div class="status-filter-popup !pt-[20px]">
    <app-checkbox-list-with-filter
      (selectionChange)="onStatusCheckboxChange($event)"
      [displaySearch]="false"
      [displaySelectAll]="true"
      [options]="statusOptions"
      [parentFormGroup]="searchForm"
      controlName="statusSearch"
    />
  </div>
</ng-template>
